<!--
  The following template is Wegue's default hover tooltip.
  It will be displayed dynamically by HoverController.js.
-->
<template>
  <wgu-map-overlay overlayId="ks-popup-tooltip" :visible=false autoPan :autoPanDuration="250" positioning="top-center"
    :offset="[0, 20]" v-slot="{ }" @update:data="handleData">
    <v-container v-if="isContainerVisible" class="ol-popup">
      <v-card-title class="d-flex justify-content-between pa-0">
        <div v-if="getTitle" class="text-body-2 pl-3">{{ getTitle }}</div>
        <v-btn icon class="ml-auto" @click="closeContainer">
          <v-icon color="white" size="small">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- 图版列表 -->
      <div v-show="isImageList">
        <v-hover v-for="(image, index) in images" :key="index" v-slot:default="{ hover }">
          <img :src="image" @click="openLightbox(index)" class="image" :class="{ 'hover': hover }" />
        </v-hover>
      </div>

      <!-- 文本列表 -->
      <div v-show="!isImageList">
        <ul>
          <li v-for="(text, index) in landInfo" :key="index">{{ text }}</li>
        </ul>
        <div v-if="features.objectType === 'insure_apply_plot'" class="text-center mt-2">
          <v-btn color="success" small :disabled="isInsuredFeature" @click="addToInsuranceList">投保</v-btn>
        </div>
      </div>
      <div><br></div>
    </v-container>
  </wgu-map-overlay>
</template>

<script>
import MapOverlay from '../modulecore/MapOverlay.vue';
import { WguEventBus } from '../../WguEventBus';

export default {
  name: 'ks-popup-tooltip',
  components: {
    'wgu-map-overlay': MapOverlay
  },
  data () {
    return {
      // 假设的图片URLs数组
      images: [],
      landInfo: [],
      imageIndex: null, // 当前放大查看的图片索引
      features: [],
      isContainerVisible: true,
      minWidth: 275,
      moduleName: 'ks-popup-tooltip',
      icon: 'help',
      overlay: false,
      zIndex: 2,
      isImageList: true
    };
  },
  created () {
    console.log('created', this.minWidth);
  },
  mounted () {
    // 在这里添加一些初始化逻辑
    this.isContainerVisible = true;

    const imageCount = Array.isArray(this.images) ? this.images.length : 0;
    console.log('mounted', imageCount, this.minWidth);
  },
  computed: {
    isInsuredFeature () {
      return this.features?.bs === 1 || this.features?.bs === '1';
    },
    getTitle () {
      if (!this.features) {
        return '';
      } else if (this.features.objectType === 'insure_apply_plot') {
        return '地块信息';
      } else if (this.features.objectType === 'landowner' || this.features.objectType === 'underwritten_plots') {
        return '投保地块信息';
      }
      return `${this.features.crop_name} ${this.features.level_name} ${this.features.note}`;
    }
  },
  methods: {
    handleClose () {
      this.imageIndex = null;
      // 在这里可以添加其他重置逻辑或状态更新
    },
    openLightbox (index) {
      this.imageIndex = index; // 设置当前查看的图片索引，打开lightbox
      // 通过imageindex 取得当前图片的url
      const image = this.images[index];
      const moduleName = 'ks-image-box';
      WguEventBus.$emit(moduleName + '-visibility-change', { visible: true, imageIndex: image });
      console.log('openLightbox', index);
    },
    closeContainer () {
      // 改变数据属性来关闭 v-container
      // this.isContainerVisible = false;
      const overlayId = 'ks-popup-tooltip';
      WguEventBus.$emit(overlayId + '-update-overlay', false);
    },
    getDisplayPlotCode (feature) {
      const externalPlotCode = String(feature?.external_plot_code || '').trim();
      if (externalPlotCode) {
        return externalPlotCode.slice(-8);
      }
      return feature?.land_id || feature?.dkbm || feature?.plot_id || feature?.id || '--';
    },
    getMaskedIdCard (feature) {
      const rawIdCard = String(
        feature?.person_id ||
        feature?.qsrid ||
        feature?.nhdm ||
        feature?.id_card ||
        feature?.owner_id_card ||
        ''
      ).trim();
      if (!rawIdCard) {
        return '--';
      }
      if (rawIdCard.includes('*')) {
        return rawIdCard;
      }
      return `*${rawIdCard.slice(-5)}`;
    },
    getDisplayLandType (feature) {
      const landType = String(feature?.land_type || feature?.DL || '').trim();
      if (!landType) {
        return '--';
      }
      if (landType === '42' || landType === '水地' || landType === '水田' || landType === '01') {
        return '水地';
      }
      if (landType === '41' || landType === '旱地' || landType === '旱田' || landType === '02') {
        return '旱地';
      }
      return landType;
    },
    handleData (data) {
      this.features = data && data.feature ? data.feature : {};
      console.log('PopUp content:', this.features); // 这里的 data 就是子组件传递过来的
      if (this.features?.objectType === 'insure_apply_plot') {
        this.isImageList = false;
        const isInsured = this.features?.bs === 1 || this.features?.bs === '1';
        const displayPlotCode = this.getDisplayPlotCode(this.features);
        const maskedIdCard = this.getMaskedIdCard(this.features);
        const displayLandType = this.getDisplayLandType(this.features);

        if (isInsured) {
          this.landInfo = [
            `保单号：${this.features.bdh || this.features.policy_no || '--'}`,
            `农户姓名：${this.features.nhxm || this.features.qsrxm || this.features.qsrmc || this.features.owner_name || '--'}`,
            `身份证号：${maskedIdCard}`,
            `作物类型：${this.features.zwlx || this.features.crop_type || '--'}`,
            `地块编号：${displayPlotCode}`
          ];
        } else {
          this.landInfo = [
            `地块名称：${this.features.land_name || this.features.dkmc || '--'}`,
            `地类：${displayLandType}`,
            `权属人：${this.features.owner_name || this.features.qsrxm || this.features.qsrmc || '--'}`,
            `身份证号：${maskedIdCard}`,
            `地块编号：${displayPlotCode}`,
            `面积：${Number(this.features.mj || this.features.area_mu || 0).toFixed(2)} 亩`
          ];
        }
      } else if (this.features?.objectType === 'landowner' || this.features?.objectType === 'underwritten_plots') {
        this.isImageList = false;
        this.landInfo = [
          `地块编号：${this.features.land_id}`,
          `地块所属人：${this.features.owner_name}`,
          `地块名称：${this.features.land_name}`,
          `地块面积：${Number(this.features.area_mu).toFixed(2)} 亩`,
          `是否投保：${this.features.insured === 1 ? '是' : '否'}`
        ];
        if (this.features.insured === 1) {
          this.landInfo.push(`被保险人：${this.features.insured_name}`);
          this.landInfo.push(`投保作物：${this.features.crop_name}`);
        }
      } else {
        this.isImageList = true;
        this.images = [
          this.features.image_1,
          this.features.image_2,
          this.features.image_3,
          this.features.image_4,
          this.features.image_5,
          this.features.image_6
        ].filter(image => typeof image === 'string' && image.trim() !== '');
        const length = this.images.length;
        this.minWidth = Math.min(375, length * 60 + 15);
      }
    },
    // Add new method to handle adding land to insurance list
    addToInsuranceList () {
      if (this.features && this.features.land_id) {
        const landPlot = {
          id: this.features.plot_id || this.features.land_id,
          plot_id: this.features.plot_id || this.features.land_id,
          land_id: this.features.land_id,
          land_name: this.features.dkmc || this.features.land_name,
          dkmc: this.features.dkmc || this.features.land_name,
          DL: this.features.DL || this.features.land_type || '',
          qsrxm: this.features.qsrxm || this.features.owner_name || '',
          qsrid: this.features.qsrid || '',
          mj: this.features.mj || this.features.area_mu || 0,
          area_mu: this.features.mj || this.features.area_mu || 0,
          ownerName: this.features.qsrxm || this.features.owner_name || '',
          owner_name: this.features.qsrxm || this.features.owner_name || '',
          insured: this.features.bs === '1' || this.features.bs === 1 ? 1 : 0,
          is_insured: this.features.bs === '1' || this.features.bs === 1 ? 1 : 0,
          bs: this.features.bs === '1' || this.features.bs === 1 ? '1' : '0',
          fromMap: true
        };
        WguEventBus.$emit('insure-apply-add-plot-to-search-list', landPlot);
        // Close the popup
        this.closeContainer();
      }
    }
  }
}
</script>

<style scoped>
/* Add your styles here */
.images-container {
  display: flex;
  flex-wrap: wrap;
  /* 允许项目换行 */
  justify-content: center;
  /* 使项目在容器中居中对齐 */
}

.image-container {
  margin: 5px;
  /* 添加一些外边距以避免图片紧挨着 */
}

.image {
  width: 60px;
  /* 设置图片宽度为100px */
  height: auto;
  /* 保持图片的原始宽高比 */
  border: 1px solid #ffffff;
  /* 添加黑色边框，你可以根据需要调整颜色和边框宽度 */
  cursor: pointer;
  /* 鼠标悬停时变为小手形状 */
}

.hover {
  width: 60px;
  /* 设置图片宽度为100px */
  border: 1px solid #c0c0c0;
  /* 添加黑色边框，你可以根据需要调整颜色和边框宽度 */
}

.right-align {
  margin-left: auto;
}

li {
  font-size: 14px;
}
</style>
